export enum ArchiveVolumeCreateType {
  MANUAL = 'MANUAL',
  AUTO_BATCH = 'AUTO_BATCH',
}

export const ArchiveVolumeCreateTypeMap = {
  [ArchiveVolumeCreateType.MANUAL]: '手动分卷',
  [ArchiveVolumeCreateType.AUTO_BATCH]: '自动批量分卷',
};

export const ArchiveVolumeCreateTypeOptions = [
  {
    label: ArchiveVolumeCreateTypeMap[ArchiveVolumeCreateType.MANUAL],
    value: ArchiveVolumeCreateType.MANUAL,
  },
  {
    label: ArchiveVolumeCreateTypeMap[ArchiveVolumeCreateType.AUTO_BATCH],
    value: ArchiveVolumeCreateType.AUTO_BATCH,
  },
];
